import { hasPermissionByDescription, verifyPermissionDescription, verifyAdminUser } from '@/components/helpers';
import { PERMISSION_IDS } from '@/constants';
import AuthService from '@/services/auth.service';
import Vue from 'vue';

import WebStorage from '@/common/WebStorage';

export const notificationPermission = Vue.extend({
	data() {
		return {
			PERMISSION_IDS,
			dataNotification: '',
            isAdmin: '',
			permission: '',
		};
	},

	async created() {
		await this.validationAcessNotification();
	},

	computed: {
		workspace() {
			return this.$store.getters.workspace;
		},
        manageNotification() {
			return hasPermissionByDescription(this.PERMISSION_IDS?.manageNotification, this.permission?.access);
		},
		createNotificationPermission() {
			return hasPermissionByDescription(this.PERMISSION_IDS?.createNotification, this.permission?.access);
		},
		editNotificationPermission() {
			return hasPermissionByDescription(this.PERMISSION_IDS?.editNotification, this.permission?.access);
		},
		deleteNotificationPermission() {
			return hasPermissionByDescription(this.PERMISSION_IDS?.deleteNotification, this.permission?.access);
		},
		createSMTPServerPermission() {
			return hasPermissionByDescription(this.PERMISSION_IDS?.createSMTPServer, this.permission?.access);
		},
		editSMTPServerPermission() {
			return hasPermissionByDescription(this.PERMISSION_IDS?.editSMTPServer, this.permission?.access);
		},

	},

	methods: {
		async validationAcessNotification() {
			this.isAdmin = await verifyAdminUser();
			this.permission = JSON.parse(WebStorage.getItem('userPermission'));
			this.dataNotification = verifyPermissionDescription(this.PERMISSION_IDS?.manageNotification, this.permission?.access);

			if (!this.dataNotification) {
				this.$router.push({
					name: 'workspace',
				});

				return this.$store.commit('activeAlert', {
					message: this.$locale.baseText('login.noPermission'),
					status: 'error',
				});
			}
		},

		canManageNotification() {
			return this.manageNotification;
		},
		canCreateNotification() {
			return this.createNotificationPermission;
		},
		canEditNotification() {
			return this.editNotificationPermission;
		},
		canCreateSMTPServer() {
			return this.createSMTPServerPermission;
		},
		canEditSMTPServer() {
			return this.editSMTPServerPermission;
		},
		canDeleteNotification() {
			return this.deleteNotificationPermission;
		}

	},
});
